import { Avatar, AvatarProps } from 'antd'
import React from 'react'
import { Candidate } from '../candidate'

export type CandidateAvatarProps = AvatarProps & { candidate: Pick<Candidate, 'avatar' | 'id' | 'name'> }

export function CandidateAvatar({ candidate, size, style, ...rest }: CandidateAvatarProps) {
    const sizeStyle = Number.isInteger(size) ? { minHeight: Number(size), minWidth: Number(size) } : {}

    return (
        <Avatar
            {...rest}
            size={size}
            src={candidate.avatar}
            style={{ ...sizeStyle, ...style }}
        />
    )

    // return (
    //     <Avatar
    //         {...rest}
    //         size={size}
    //         style={{ ...sizeStyle, backgroundColor: '#' + candidate.id.replace(/-/g, '').slice(-6) }}
    //     >
    //         {candidate.name
    //             .split(' ')
    //             .map((part) => part[0])
    //             .join('')}
    //     </Avatar>
    // )
}
